import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";

export default function BookingDeposit() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const tries = useRef(0);

  useEffect(() => {
    if (!bookingId || !sessionId) { setStatus("failed"); return; }
    const poll = async () => {
      try {
        const { data } = await api.post(`/bookings/${bookingId}/confirm-deposit`, { session_id: sessionId });
        if (data.status === "confirmed") { setStatus("confirmed"); return; }
      } catch (e) { /* retry */ }
      tries.current += 1;
      if (tries.current < 15) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [bookingId, sessionId]);

  return (
    <div data-testid="booking-deposit-page" className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        {status === "checking" && (
          <>
            <Loader2 className="w-12 h-12 text-primary mx-auto animate-spin" />
            <h1 className="font-display text-3xl mt-6">Confirming your deposit</h1>
            <p className="text-muted-foreground mt-3 text-sm">Hold on while we verify your payment...</p>
          </>
        )}
        {status === "confirmed" && (
          <>
            <CheckCircle2 data-testid="deposit-confirmed-icon" className="w-12 h-12 text-emerald-500 mx-auto" />
            <h1 className="font-display text-3xl mt-6">Deposit paid — you're booked</h1>
            <p className="text-muted-foreground mt-3 text-sm">Your table is confirmed. A confirmation email is on its way.</p>
            <Link to="/restaurants">
              <Button data-testid="deposit-back-btn" className="mt-8 rounded-full">Back to restaurants</Button>
            </Link>
          </>
        )}
        {(status === "pending" || status === "failed") && (
          <>
            <XCircle className="w-12 h-12 text-amber-400 mx-auto" />
            <h1 className="font-display text-3xl mt-6">Payment not confirmed</h1>
            <p className="text-muted-foreground mt-3 text-sm">If your payment went through, your booking will confirm shortly. Otherwise please try booking again.</p>
            <Link to="/restaurants">
              <Button data-testid="deposit-retry-btn" variant="outline" className="mt-8 rounded-full">Back to restaurants</Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
